class SliderComponentSwiper extends HTMLElement {
    constructor() {
        super();
        this.wlSwiper = null;
        this.column_on_desktop = Number(this.getAttribute('data-column-desktop') || 4);
        this.column_on_tablet = Number(this.getAttribute('data-column-tablet') || 3);
        this.column_on_mobile = this.getAttribute('data-column-mobile') === "auto" ? "auto" : Number(this.getAttribute('data-column-mobile')) || 2;
        
        this.space_between_desktop = Number(this.getAttribute('data-space-between-desktop') || 32);
        this.space_between_tablet = Number(this.getAttribute('data-space-between-tablet') || 18);
        this.space_between_mobile = Number(this.getAttribute('data-space-between-mobile') || 6);
        this.auto_play_time = Number(this.getAttribute('data-auto-play-time')) || null;
        this.direction = this.getAttribute('data-direction') || 'horizontal';
        this.is_loop = this.getAttribute('data-is-loop') !== "false";

        this.init();
    }
  
    init() {
        const auto_play_time = {
            autoplay: {
                delay: this.auto_play_time,
            },
        }
        this.wlSwiper = new Swiper(this, {
            enabled: true,
            loop: this.is_loop,
            slidesPerView: this.column_on_mobile,
            spaceBetween: this.space_between_mobile,
            centeredSlides: false,
            centeredSlidesBounds: false,
            centerInsufficientSlides: false,
            keyboardControl: true,
            grabCursor: true,
            paginationClickable: true,
            navigation: true,
            direction: this.direction,
            ...(this.auto_play_time && auto_play_time),
            breakpoints: {
                750: {
                    slidesPerView: this.column_on_tablet,
                    spaceBetween: this.space_between_tablet,
                },
                990: {
                    slidesPerView: this.column_on_desktop,
                    spaceBetween: this.space_between_desktop,
                }
            }
        });
    }
}

customElements.define('slider-component-swiper', SliderComponentSwiper);